// vnode.data 内部使用的几个字段

export const ID = '$id'

export const VNODE = '$vnode'

export const LOADING = '$loading'

export const COMPONENT = '$component'

export const LEAVING = '$leaving'